import React, { useEffect } from 'react'
import { Navigate } from 'react-router-dom'

/**
 * Component that redirects agents away from company owner routes
 */
export const AgentRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const userType = localStorage.getItem('user_type')
  
  useEffect(() => {
    if (userType === 'agent') {
      console.log('🚫 Agent detected on company owner route, redirecting to /agent/dashboard')
      window.location.replace('/agent/dashboard')
    }
  }, [userType])
  
  // If agent, redirect immediately
  if (userType === 'agent') {
    return <Navigate to="/agent/dashboard" replace />
  }
  
  // Otherwise, render children (company owner content)
  return <>{children}</>
}

export default AgentRedirect